import { DataBean } from "../DataBean";

export class CreditProperties extends DataBean {


    public async getCreditPropertyRender(page:any,maxRows:any,props:any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getCreditPropertyRender_Number_Number_java.util.Map", [page,maxRows,props]);
    }

    public async getCreditPropertyDefinition(page:any,maxRows:any,group:any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getCreditPropertyDefinition_Number_Number_String", [page,maxRows,group]);
    }
    public async getCreditPropertyGroup(id:any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getCreditPropertyGroup_Number", [id]);
    }

    public async deleteCreditProperties(idcreditproperties:any): Promise<any> {
        return this.getCustomService("CreditCore", "boolean_deleteCreditProperties_Number", [idcreditproperties]);
    }

 
}